
export default {
  test: "f619478ee97dc0c338ad210d26c7f5b000c8a9d20eafd5a282ae38a340677217",
  pre: "bb4453da6142be54d86672e6c96432a3160e4ba4c034a226a66a168792397a84",
  production: "ee2265b429f7e2652292c548df809f3378f5ef0c41b1ff5c5d77bd453af70026",
  zh:{
    production: "0818cdba4023833198b4949efbbe802fe014fa033ec1abe9f0c67abf888a30c7"
  }
}